
<template>
  <header>
    <div class="tabbar">
      <nav>
        <!-- ヘッダーナビゲーション（mobile） -->
        <c-header-navigation :mode="mobile" />
      </nav>
    </div>
    <div class="navbar">
      <input id="navinput" type="checkbox">
      <label for="navinput" id="navclose"></label>
      <nav>
        <!-- headerロゴ -->
        <c-header-logo v-tooltip="`広場へ`" ></c-header-logo>
        <!-- アカウント情報(mobile) -->
        <c-account-info-mobile v-if="Boolean(loginFlg)" ></c-account-info-mobile>

        <!-- ゲスト情報(mobile) -->
        <div class="user guest" v-show="!Boolean(loginFlg)">
          <div class="cover">
            <div class="image"><img src="/assets/icon-guest.svg" alt="ゲスト"></div>
          </div>
          <div class="status">
            <div class="name">ゲストさん</div>
            <div class="action">
              <label class="login" for="login-drawer">ログイン</label>
              <label class="signin" for="signin-drawer">新規登録</label>
            </div>
          </div>
        </div>
        <!-- ヘッダーナビゲーション（PC） -->
        <c-header-navigation :mode="pc" />
        <!-- フッターナビゲーション（mobile） -->
        <c-footer-navigation :mode="mobile" />
      </nav>

      <div class="logo"><router-link to="/"><img src="/assets/logo.svg" alt="ともつくネット"></router-link></div>
      <!-- お知らせ（吹き出し） -->
      <div class="notification" v-if="account != null || temporaryAccount != null">
        <label for="notificationinput" id="notificationclose" v-tooltip="'お知らせ'">
          <span v-show="notificationCount > 0">{{notificationCount}}</span>
          <a href="#" @click.prevent="toggleNotificationchecked" ><img src="/assets/icon-notification.svg" alt="あなたへの通知"></a>
        </label>
        <c-notifications-tooltip></c-notifications-tooltip>
      </div>

      <div class="tool">
        <!--<div class="search" v-tooltip="'キーワード検索'">
          <input id="searchinput" type="checkbox">
          <label for="searchinput" id="searchclose" @click="toggleSearchContainerDisplay"><img src="/assets/icon-search.svg" alt="投稿を検索"></label>
        </div>
        
        <c-keyword-search-dialog v-show="keywordSearchContainerDisplay" />-->

        <div id="drawer-form" v-show="!Boolean(loginFlg)">
          <input type="radio" name="drawer" id="login-drawer">
          <input type="radio" name="drawer" id="signin-drawer">
          <label class="login" for="login-drawer">ログイン</label>
          <label class="signin" for="signin-drawer">新規登録</label>
          <c-temporary-sign-in></c-temporary-sign-in>
          <c-account-login></c-account-login>
        </div>
        <!-- アカウント情報（PC） -->
        <c-account-info-pc v-if="Boolean(loginFlg)" v-tooltip="account.last_name + account.first_name" />
      </div>
    </div>
    <div class="brank"></div>
  </header>
</template>
<script setup>
import { computed, onMounted, ref, watch } from "vue"
import { useStore } from 'vuex'
import {useToast} from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'

import Global from '../js/constant.js'
import Common from '../js/common.js'
import axios from "axios"

// store取得
const $store = useStore();
const $toast = useToast();

// --- define state ---
const notificationCount = ref(0);

// --- computed ---
const account = computed(() => $store.state.core.account);
const loginFlg = computed(() => $store.state.core.loginFlg);
const clientErrors = computed(() => $store.state.error.clientErrors);
// const keywordSearchContainerDisplay = computed(() => $store.state.keywordSearch.keywordSearchContainerDisplay);
const notificationContainerDisplay = computed(() => $store.state.notification.notificationContainerDisplay);
const temporaryAccount = computed(() => $store.state.core.temporaryAccount);

const pc = computed(() => Global.device_division_id.pc);
const mobile = computed(() => Global.device_division_id.mobile);

// action操作はdispatch
const getAccountFollows = (account) => $store.dispatch('getAccountFollows', account);
const getCircles = (account) => $store.dispatch('getCircles', account);
const getCircleFollows = (account) => $store.dispatch('getCircleFollows', account);
const getFollowers = (account) => $store.dispatch('getFollowers', account);
const getFavorCircles = (account) => $store.dispatch('getFavorCircles', account);
const getMyCircles = (account) => $store.dispatch('getMyCircles', account);
const restore = () => $store.dispatch('restore');

// mutation操作はcommit
const setClientErrors = (val) => $store.commit('setClientErrors', val);
// const setKeywordSearchContainerDisplay = (val) => $store.commit('setKeywordSearchContainerDisplay', val);
const setLoginFlg = (flg) => $store.commit('setLoginFlg', flg);
const setNotificationContainerDisplay = (val) => $store.commit('setNotificationContainerDisplay', val);

// --- watch --- 関数は ref を直接扱えます
watch(loginFlg, (newLoginFlg) => {
  if (!newLoginFlg) {
    notificationCount.value = 0;
  }
});

watch(() => temporaryAccount, (newValue) => {
  alert('未検証');
  if (newValue != null) {
    getNotificationCountCaseNologin();
  }
});

watch(account, (newAccount) => {
  initAll(newAccount)
});


watch(clientErrors, (newClientErrors) => {
  if (newClientErrors != null) {
    sendErrors()
  }
});

// --- methods ---
const initAll = async (account) => {
  if (account) {
    notificationCount.value = 0
    getNotificationCount(account)
  }
  getMyCircles(account)
  getCircles(account)
  getAccountFollows(account)
  getCircleFollows(account)
  getFollowers(account)
  getFavorCircles(account)
};
/**
 * 自動ログイン
 */
const searchAutoLogin = async () => {
  let params = {account_id: $store.state.core.account.id}
  return await axios.post(Global.url.api_auto_logins_search, params)
  .then(result => {
    if (result.data.status === Global.api_status.success) {
      if (result.data.auto_login.auto_id == $store.state.core.autoId) {
        console.log("auto_id 一致")
        return true
      } else {
        console.log("auto_id 一致しない")
        return false
      }
    }
  })
  .catch(error => {
    console.log(error);
    $toast.error('client error');
    setClientErrors({func:"common/header/Header.vue::searchAutoLogin", params: {}, errorMessage:error})
  })
};

/**
 * 
 */
const getNotificationCountCaseNologin = () => {
  if (temporaryAccount.value != null) {
    notificationCount.value = 1
  }
};

/**
 * 
 */
const getNotificationCount = async (account) => {
  let params = {
    account_id : account.id,
  }
  params['offset'] = 0;
  await axios.post(Global.url.api_entries_notifications, params)
  .then(res => {
    if (res.data.status == Global.api_status.success) {
      notificationCount.value = res.data.entries.filter(row => row.is_unread).length
      return
    }
  })
  .catch(error=>{
    $toast.error('client error');
    setClientErrors({func:"common/header/Header.vue::getNotificationCount", params: {}, errorMessage:error})
  })
};

/**
 * 
 */
const toggleNotificationchecked = () => {
  setNotificationContainerDisplay(!notificationContainerDisplay.value)
};

/**
 * 
 */
 const sendErrors = () => {
  axios.post(Global.url.api_client_errors_modify, {
    function: clientErrors.value.func,
    parameters: JSON.stringify(clientErrors.value.params),
    error_message: "" + clientErrors.value.errorMessage
  }).then(res => {
    if (res.data.status === Global.api_status.success) {
      setClientErrors(null)
    }
  })
};

// --- created ---
(() => {
  restore();
})()

// --- mounted ---
onMounted(async () => {
  if ($store.state.core.host === Common.getUrlHost()) {
    // 自動ログイン処理
    if ($store.state.core.autoId) {
      // auto_loginテーブル検索
      let loginResult = await searchAutoLogin();
      if (loginResult) {
        setLoginFlg(true);
        initAll($store.state.core.account);
      }
    }
  }
});
</script>